import { useEffect, useRef, useState } from "react";
import { api } from "./api.js";

// useApi("model/kpis") -> { data, error, loading }
export function useApi(path, deps = []) {
  const [state, setState] = useState({ data: null, error: null, loading: true });
  const prevPath = useRef(path);
  useEffect(() => {
    let alive = true;
    // When the PATH changes (e.g. an account switch flips ?broker/env, or a new
    // ticker), the old resource's data is STALE — drop it so the previous account's
    // book never flashes under the newly-selected one. A deps-only refetch (same
    // path, e.g. a manual tick) keeps the current data visible while it refreshes.
    const pathChanged = prevPath.current !== path;
    prevPath.current = path;
    setState((s) => (pathChanged ? { data: null, error: null, loading: true } : { ...s, loading: true }));
    api(path)
      .then((data) => alive && setState({ data, error: null, loading: false }))
      .catch((error) => alive && setState({ data: null, error, loading: false }));
    return () => {
      alive = false;
    };
    // include `path` so the hook refetches when the path changes (not just deps)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);
  return state;
}
